import styles from './Users.module.css';
import ArrowBelow from '../../assets/arrow_below.svg';
import { ToastContainer } from 'react-toastify';
import { useUsers } from './useUsers';

const Users = () => {
    const {
        users,
        clients,
        userTableLineId,
        handleRowClick,
        handleClientChange,
        handleUserRole,
        loading,
    } = useUsers();

    return (
        <div className={styles.container}>
            <ToastContainer />
            <div className={styles.infoLine}>
                <div className={styles.infoLineHead}>
                    <img src={ArrowBelow} alt="Seta para baixo" />
                    <h4 className={styles.headerInfo}>Tabela de Usuários</h4>
                </div>  
                <div className={styles.infoLineSelected}>
                    <select className={styles.clientDropdown} onChange={handleClientChange}>
                        <option value="" disabled selected>Selecione um cliente</option>
                        {clients.map((client) => (
                            <option key={client.id} value={client.id}>
                                {client.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className={styles.tableItems}>
                <table>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nome</th>
                            <th>CPF/Email</th>
                            <th>Função</th>
                            <th>Senha</th>
                            <th>Telefone</th>
                        </tr>
                    </thead>

                    <tbody>
                        {users.map((user) => (
                            <tr 
                                key={user.id}
                                onClick={() => handleRowClick(user)}
                                className={user.id === userTableLineId ? styles.selectedRow : ''}>
                                <td>{user.id}</td>
                                <td>{user.name}</td>
                                <td>{user.username}</td>
                                <td>{handleUserRole(user.role)}</td>
                                <td>**********</td>
                                <td>{user.phone}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Users;